<template>
    <div class="col">
        <div class="card mb-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                Scheduled Appointments
                <div>
                    <a class="btn btn-sm btn-outline-primary" :href="'/appointments/create?attendee_participant_id='+participant.id" aria-label="Create Appointment">
                        <icon-plus :width=16 :height=16 />
                    </a>
                </div>
            </div>
            <div class="card-body">
                <div v-if="loading" class="bg-muted text-muted text-center">Loading appointments...</div>
                <div v-else>
                    <ul class="list-unstyled">
                        <li v-for="appt in displayedAppointments" :key="appt.id">
                            <appointment-list-item :appointment="appt"></appointment-list-item>
                        </li>
                    </ul>
                    <div v-if="displayedAppointments.length == 0" class="bg-muted text-muted text-center">No appointments found</div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <button class="btn btn-link" @click="showAll=!showAll">{{ toggleListLabel }}</button>
        </div>
    </div>
</template>

<script>
import AppointmentListItem from './AppointmentListItem.vue'
import IconPlus from '../shared/IconPlus.vue'

export default {
    name: "AppointmentSidebar",
    components: {
        AppointmentListItem,
        IconPlus
    },
    props: { 
        participant: Object,
    },
    data() {
        return {
            appointments: [],
            loading: false,
            showAll: false,
        }       
    },
    methods: {
        fetchAppointments() {
            this.loading = true

            axios.get('/api/participants/'+this.participant.id+'/appointments')
                .then( (response) => {
                    this.appointments = response.data.data
                    this.loading = false
                })
                .catch( (e) => {
                    console.log("Error: AppointmentSidebar.vue, fetchAppointments(), "+ e.message)          
                })
        }
    },
    computed: {
        displayedAppointments() {
            return this.showAll ? this.appointments : this.scheduledAppointments
        },
        scheduledAppointments() {
            return this.appointments.filter((appt) => appt.appointment_status.name == 'Scheduled')
        },
        toggleListLabel() {
            return this.showAll ? 'Show Scheduled Appointments Only' : 'Show All Appointments'
        }
    },
    mounted () {
    	this.fetchAppointments()
    }
}

</script>